"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRITE_STYLE_HTTP = exports.WRITE_STYLE = exports.DATA_SOURCE_TYPES = exports.REVERT_ALL = exports.SAVE_ALL = exports.STANDALONE_ITEM = exports.MAX_LRU_SIZE = exports.MAX_LRU_COUNT = exports.AUTH_LOGOUT_ERROR = exports.AUTH_LOGOUT_SUCCESS = exports.AUTH_LOGOUT_REQUEST = exports.AUTH_LOGOUT_SYNC = exports.AUTH_LOGIN_ERROR = exports.AUTH_LOGIN_SUCCESS = exports.AUTH_LOGIN_REQUEST = exports.AUTH_LOGIN_SYNC = exports.ADD_SERVER_TEMPORARY = exports.RECEIVE_SAVE_UNAUTHORIZED = exports.RECEIVE_SAVE_ERROR = exports.RECEIVE_SAVE = exports.REQUEST_SAVE = exports.REVERT_DRAFT = exports.VALIDATE_EXTERNAL = exports.UPDATE_DRAFT = exports.RESTORE_DRAFT = exports.REMOVE_DRAFT = exports.ADD_DRAFT = exports.CLEANUP = exports.SERVER_DATA_AVAILABLE = exports.UNSUBSCRIBE = exports.SUBSCRIBE = exports.RECEIVE_MODEL_UNAUTHORIZED = exports.RECEIVE_UNAUTHORIZED = exports.RECEIVE_ERROR = exports.RECEIVE = exports.REQUEST = exports.RECEIVE_MODEL_ERROR = exports.RECEIVE_MODEL = exports.REQUEST_MODEL = exports.META = exports.READ = exports.DEFAULT_CONNECT_META_POSTFIX = exports.DEFAULT_API_GROUP_NAME = exports.DEFAULT_API_FILTER_DISABLED = exports.DEFAULT_API_FILTER_NAME = undefined;

var _constant;

exports.filterDefault = filterDefault;
exports.subscribeFilterDefault = subscribeFilterDefault;
exports.groupName = groupName;
exports.constant = constant;

var _immutable = require("immutable");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_API_FILTER_NAME = exports.DEFAULT_API_FILTER_NAME = "unfiltered";
var DEFAULT_API_FILTER_DISABLED = exports.DEFAULT_API_FILTER_DISABLED = "disabled";

/*
 * Use default filter name if filter is undefined.
 */
function filterDefault() {
  var alias = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var only = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

  if (alias !== undefined) {
    return alias;
  }

  // LEGACY: A filter without anything else just shows as the plain filter.
  if (filter !== undefined && sort === undefined && only === undefined) {
    return filter;
  }

  // Combine all elements into a single filter name.
  var parts = [];
  if (filter !== undefined) {
    parts.push("filter=" + filter);
  }
  if (sort !== undefined) {
    if (_immutable.Set.isSet(sort) || _immutable.List.isList(sort) || Array.isArray(sort)) {
      parts.push("sort=" + sort.join('+'));
    } else {
      parts.push("sort=" + sort);
    }
  }
  if (only !== undefined) {
    if (_immutable.Set.isSet(only) || _immutable.List.isList(only) || Array.isArray(only)) {
      parts.push("only=" + (0, _immutable.Set)(only).join('+'));
    } else {
      parts.push("only=" + only);
    }
  }
  if (limit !== undefined) {
    parts.push("limit=" + limit);
  }

  if (parts.length > 0) {
    return parts.join('&');
  } else {
    return DEFAULT_API_FILTER_NAME;
  }
}

function subscribeFilterDefault() {
  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  return filter || DEFAULT_API_FILTER_NAME;
}

var DEFAULT_API_GROUP_NAME = exports.DEFAULT_API_GROUP_NAME = "ungrouped";
/*
 * Use default group name if group is undefined.
 */
function groupName() {
  var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  return group || DEFAULT_API_GROUP_NAME;
}

var DEFAULT_CONNECT_META_POSTFIX = exports.DEFAULT_CONNECT_META_POSTFIX = 'Meta';

/*
 * Group Constants
 */
function constant(items) {
  if (!('ALL' in items)) {
    throw new Error('Must include ALL in constants.  Constant: ' + items);
  }

  // Set the ALL constant
  var all = {};
  Object.keys(items).forEach(function (key) {
    if (key !== 'ALL') {
      items.ALL[key] = key;
    }
  });
  items.ALL = all;

  return items;
}

/*
 * ACTIONS
 */
var READ = exports.READ = 'READ';
var META = exports.META = 'META';

var REQUEST_MODEL = exports.REQUEST_MODEL = 'REQUEST_MODEL';
var RECEIVE_MODEL = exports.RECEIVE_MODEL = 'RECEIVE_MODEL';
var RECEIVE_MODEL_ERROR = exports.RECEIVE_MODEL_ERROR = 'RECEIVE_MODEL_ERROR';

var REQUEST = exports.REQUEST = 'REQUEST';
var RECEIVE = exports.RECEIVE = 'RECEIVE';
var RECEIVE_ERROR = exports.RECEIVE_ERROR = 'RECEIVE_ERROR';
var RECEIVE_UNAUTHORIZED = exports.RECEIVE_UNAUTHORIZED = 'RECEIVE_UNAUTHORIZED';
var RECEIVE_MODEL_UNAUTHORIZED = exports.RECEIVE_MODEL_UNAUTHORIZED = 'RECEIVE_MODEL_UNAUTHORIZED';

var SUBSCRIBE = exports.SUBSCRIBE = 'SUBSCRIBE';
var UNSUBSCRIBE = exports.UNSUBSCRIBE = 'UNSUBSCRIBE';
var SERVER_DATA_AVAILABLE = exports.SERVER_DATA_AVAILABLE = 'SERVER_DATA_AVAILABLE';

var CLEANUP = exports.CLEANUP = 'CLEANUP';

var ADD_DRAFT = exports.ADD_DRAFT = 'ADD_DRAFT';
var REMOVE_DRAFT = exports.REMOVE_DRAFT = 'REMOVE_DRAFT';
var RESTORE_DRAFT = exports.RESTORE_DRAFT = 'RESTORE_DRAFT';
var UPDATE_DRAFT = exports.UPDATE_DRAFT = 'UPDATE_DRAFT';
var VALIDATE_EXTERNAL = exports.VALIDATE_EXTERNAL = 'VERIFY_DRAFT';
var REVERT_DRAFT = exports.REVERT_DRAFT = 'REVERT_DRAFT';

var REQUEST_SAVE = exports.REQUEST_SAVE = 'REQUEST_SAVE';
var RECEIVE_SAVE = exports.RECEIVE_SAVE = 'RECEIVE_SAVE';
var RECEIVE_SAVE_ERROR = exports.RECEIVE_SAVE_ERROR = 'RECEIVE_SAVE_ERROR';
var RECEIVE_SAVE_UNAUTHORIZED = exports.RECEIVE_SAVE_UNAUTHORIZED = 'RECEIVE_SAVE_UNAUTHORIZED';

var ADD_SERVER_TEMPORARY = exports.ADD_SERVER_TEMPORARY = 'ADD_SERVER_TEMPORARY';

var AUTH_LOGIN_SYNC = exports.AUTH_LOGIN_SYNC = 'AUTH_LOGIN_SYNC';
var AUTH_LOGIN_REQUEST = exports.AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
var AUTH_LOGIN_SUCCESS = exports.AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
var AUTH_LOGIN_ERROR = exports.AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR';
var AUTH_LOGOUT_SYNC = exports.AUTH_LOGOUT_SYNC = 'AUTH_LOGOUT_SYNC';
var AUTH_LOGOUT_REQUEST = exports.AUTH_LOGOUT_REQUEST = 'AUTH_LOGOUT_REQUEST';
var AUTH_LOGOUT_SUCCESS = exports.AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
var AUTH_LOGOUT_ERROR = exports.AUTH_LOGOUT_ERROR = 'AUTH_LOGOUT_ERROR';

/*
 * Least Recently Used Cache
 */
var MAX_LRU_COUNT = exports.MAX_LRU_COUNT = 9007199254740991;
var MAX_LRU_SIZE = exports.MAX_LRU_SIZE = 500;

/*
 * COLLECTION/ITEM CONSTANTS
 */
var STANDALONE_ITEM = exports.STANDALONE_ITEM = Symbol('STANDALONE_ITEM');

/*
 * SAVE CONSTANTS
 */
var SAVE_ALL = exports.SAVE_ALL = Symbol('SAVE_ALL');

/*
 * REVERT CONSTANTS
 */
var REVERT_ALL = exports.REVERT_ALL = Symbol('REVERT_ALL');

/*
 * MODEL TYPES (for Api module)
 */
var DATA_SOURCE_TYPES = exports.DATA_SOURCE_TYPES = constant({
  ITEM: 'item',
  COLLECTION: 'collection',
  ALL: []
});

/*
 * WRITE STYLE (for Api module)
 */
var WRITE_STYLE = exports.WRITE_STYLE = constant({
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  ALL: []
});

/*
 * WRITE STYLE_HTTP (for fetchWriter)
 */
var WRITE_STYLE_HTTP = exports.WRITE_STYLE_HTTP = constant((_constant = {}, _defineProperty(_constant, WRITE_STYLE.CREATE, 'POST'), _defineProperty(_constant, WRITE_STYLE.UPDATE, 'PATCH'), _defineProperty(_constant, WRITE_STYLE.DELETE, 'DELETE'), _defineProperty(_constant, "ALL", []), _constant));